import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getToolsURL } from '../utils/api';

const useGetTools = ({ 
        page = 1,
        limit = 10,
        keyword, 
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingTools, setGettingTools ] = useState(false);
    const [ tools, setTools ] = useState([]);
    const [ totalTools, setTotalTools ] = useState(0);
    const [ gettingToolsReqSuccess, setGettingToolsReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingTools) {
            axios.get(getToolsURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword
                }
            }).then(result => {
                setGettingTools(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalTools(result.data.total);
                    }
                    setGettingToolsReqSuccess(true);
                    setTools(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingToolsReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingToolsReqSuccess(false);
                setGettingTools(false);
            });
        }
    }, [gettingTools]);

    return { tools, totalTools, gettingTools, setGettingTools, gettingToolsReqSuccess };
}

export default useGetTools;